const Posta = resolve => {
    require.ensure(['../views/apps/posta/Posta'], () => {
        resolve(require('../views/apps/posta/Posta'))
    })
};
const PostaKodlari = resolve => {
    require.ensure(['../views/apps/posta/PostaKodlari'], () => {
        resolve(require('../views/apps/posta/PostaKodlari'))
    })
};


import Vue from 'vue'
Vue.component('PostaKodlari', PostaKodlari);

import layouts from '../layout'

export default {
    path: '/posta',
    name: 'posta',
    component: Posta,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
}
